// extracted by mini-css-extract-plugin
export default {"contactSupportLink":"contactSupportLink__fHcXtae9","contactSupportText":"contactSupportText__RI8B9I76"};